/**
 * Placeholder image data URL to avoid 422 errors for missing placeholder.jpg
 * This creates a simple gray box with "No Image Available" text
 */
export const PLACEHOLDER_IMAGE = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect width="400" height="400" fill="%23333"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" fill="%2310b981" font-family="Arial" font-size="20"%3ENo Image Available%3C/text%3E%3C/svg%3E';

export default PLACEHOLDER_IMAGE;








